// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__hFPay","col":"styles_col__34KQH","fulfillmentStatus":"styles_fulfillmentStatus__-3BMR","emailCol":"styles_emailCol__3_mOk"};